import styled from 'styled-components'
import { Avatar } from '@components/Avatar'
import {
	backgroundOrange,
	orange,
	gold,
	black,
	textMuted,
	border1,
} from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text, tracking, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { cardSurface, liftOnHover } from '@components/Card'
import { Pill } from '@components/Pill'


export const LoadingContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    background-color: ${backgroundOrange};
    height: 100%;
`




/** Main CTA — the page's one primary. */
export const AddButton = styled(Button)``

export const FlightGroupGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 360px));
    gap: 16px;
    justify-content: start;

    ${media.phone} {
        grid-template-columns: 1fr;
    }
`

/** A white card on the page ground; the whole card opens the flight group, so it lifts on hover. */
export const FlightGroupCard = styled.div`
	${cardSurface}
	${liftOnHover}
	padding: 16px 18px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`

export const FlightGroupHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`

export const FlightGroupTitle = styled.div`
    font-size: ${fontSizes.small};
    font-weight: 700;
    color: ${black};
`

export const ManualPill = styled(Pill).attrs({ $tone: 'dark' as const })``

export const RouteBlock = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 12px;
    padding: 8px 0 4px;
`

export const RouteEndpoint = styled.div<{ $align: 'start' | 'end' }>`
    display: flex;
    flex-direction: column;
    align-items: ${({ $align }) => ($align === 'start' ? 'flex-start' : 'flex-end')};
    text-align: ${({ $align }) => ($align === 'start' ? 'left' : 'right')};
    gap: 4px;
    min-width: 0;
`

export const RouteAirport = styled.span`
    font-size: ${fontSizes.title};
    font-weight: 900;
    color: ${black};
    letter-spacing: ${tracking.tight};
    line-height: ${leading.none};
`

export const RouteLabel = styled.span`
    ${text.eyebrow}
    color: ${gold};
`

export const RouteTime = styled.span`
    font-size: ${fontSizes.micro};
    font-weight: 700;
    color: ${black};
    white-space: nowrap;
`

export const RouteArrow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${orange};
    position: relative;
    min-width: 48px;
    padding: 0 4px;

    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 0;
        border-top: 1.5px dashed ${orange}66;
        min-width: 10px;
    }

    svg {
        margin: 0 6px;
        flex-shrink: 0;
    }
`

export const PassengerRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding-top: 8px;
    border-top: 1px solid ${border1};
    flex-shrink: 0;
    min-height: 32px;
`

export const AvatarStack = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`

/** One face in the passenger / guest stack: overlaps the one before it and sits under it. */
export const StackedAvatar = styled(Avatar)<{ $index: number }>`
    margin-left: ${({ $index }) => ($index > 0 ? '-6px' : '0')};
    z-index: ${({ $index }) => 10 - $index};
`


export const PassengerCount = styled.span`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
    font-weight: 500;
    white-space: nowrap;
`

export const YoureAPassengerPill = styled(Pill).attrs({ $tone: 'success' as const })`
	margin-left: auto;
	flex-shrink: 0;
`
